import {onValue} from 'firebase/database';
import {createRealtimeDBRef} from 'network/firebase';
import {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';

const usePharmacy = () => {
  const navigate = useNavigate();
  const [pharmacyList, setPharmacyList] = useState<string[]>();

  const navigateToPharmacyDetails = (pharmacy: string) => {
    console.log(`trying to navigate to /pharmacy-details/${pharmacy}`);
    navigate('/pharmacy-details', {state: {pharmacy}});
  };

  useEffect(() => {
    const drugListRef = createRealtimeDBRef();

    onValue(drugListRef, (snapshot) => {
      const pharmacyItemList: string[] = Object.values(
        Object.keys(snapshot.val()),
      );
      setPharmacyList(pharmacyItemList);
    });
  }, []);

  return {
    pharmacyList: pharmacyList,
    navigateToPharmacyDetails,
  };
};

export default usePharmacy;
